import { IonPage } from "@ionic/react";
import { Redirect } from "react-router-dom";
import { OnboardingSlides } from "@/components/onboarding/onboarding-slides";
import { useOrganizationConfig } from "@/hooks/use-organization-config";
import { Routes } from "@/lib/router";

export function OnboardingPage() {
  const { data: config, isLoading } = useOrganizationConfig();

  // Show loading spinner while fetching config
  if (isLoading) {
    return (
      <IonPage>
        <div className="flex h-full items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-bordercolor-brand border-t-transparent" />
        </div>
      </IonPage>
    );
  }

  // If no config or no onboarding data, redirect to sign-in
  // This allows the backend to disable onboarding dynamically without app rebuild
  if (!config || !config.onboarding) {
    return <Redirect to={Routes.AuthSignInPassword()} />;
  }

  return (
    <IonPage>
      <OnboardingSlides
        config={config.onboarding}
        organizationName={config.name}
        primaryColor={config.colors.primary}
        primaryContrast={config.colors.primaryContrast}
      />
    </IonPage>
  );
}
